import { NextSeo } from "next-seo"
import useT from "utils/useT"
import SearchPage from "../views/search"
import { GetServerSideProps } from "next"
import { ParsedUrlQuery } from "querystring"

interface Props {
  query: ParsedUrlQuery
}
const Search = ({ query }: Props) => {
  const t = useT()

  return (
    <>
      <NextSeo
        title={"search for iOS iPhone apps or games | Appollow"}
        facebook={{ appId: "381042603551124" }}
        description={t.search.hero}
        openGraph={{
          url: "https://www.appollow.net/submit",
          title: "search for iOS iPhone apps or games | Appollow",
          description: t.search.hero,
          siteName: "Appollow",
        }}
        twitter={{
          site: "@Appollowapp",
          cardType: "summary_large_image",
        }}
      />
      <SearchPage serverQuery={query} />
    </>
  )
}
export default Search

export const getServerSideProps = (async ({ query }) => {
  return {
    props: {
      query,
    },
  }
}) satisfies GetServerSideProps<Props>
